/**
 *  Behavior error
 *
 *  @class BehaviorError
 *  @extends Error
 */
class BehaviorError extends Error {
  constructor(debugMessage,
  // eslint-disable-next-line default-param-last
  statusCode = 500, errorData, cause, options = {}) {
    var _options$errorCode;
    super(debugMessage, cause ? {
      cause
    } : undefined);
    if (errorData) {
      this.prodData = errorData;
    }
    Error.captureStackTrace(this, this.constructor);
    this.name = 'BehaviorError';
    this.statusCode = statusCode;
    this.debugMessage = debugMessage;
    this.messageKey = 'nativebehavior_error';
    this.logLevel = 'error';

    // `errorCode` is the curated, client-facing code; `code` is kept as a
    // backward-compatible alias.
    this.errorCode = (_options$errorCode = options.errorCode) !== null && _options$errorCode !== void 0 ? _options$errorCode : options.code;
    this.detailKey = options.detailKey;
    this.hintKey = options.hintKey;
    this.detail = options.detail;
    this.hint = options.hint;
    if (cause !== null && cause !== void 0 && cause.stack) {
      this.stack = `${this.stack}\n\nCaused by:\n${cause.stack}`;
    }
  }
}
module.exports = BehaviorError;